// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__OHLGQ","label":"Category_label__1ShKj","content":"Category_content__Y77Xd","header":"Category_header__1x8wn","location":"Category_location__1tyNd"};